module.exports = __webpack_public_path__ + "img/fm-Path 43 Copy@3x.dad1c350.png";